'use strict';

var React = require('react');
var $ = require('jquery');
var FormattedHTMLMessage = require('react-intl').FormattedHTMLMessage;
var i18n = require('../../utils/i18n');
var Analytics = require('../../utils/Analytics');
var griffinKeyCreator = require('../../utils/content').griffinKeyCreator;
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

var FEATURES_KEYS_PREFIX = 'fees.feature.';
var FEATURES_KEYS = ['no_fees', 'free_direct_deposit', 'free_withdrawals', 'load_cash'];

var TABLE_KEYS_PREFIX = 'fees.table.';
var TABLE_HEADERS_KEYS = ['all_fees', 'amount', 'details'];
var TABLE_DETAILS_KEYS_SUFFIX = ['.name', '.amount', '.details'];
var TABLE_HEADERS_KEYS_SUFFIX = '.header';

var v2ContentKeys = [
    'fees.table.spend_money.cash_card_purchases.name',
    'fees.table.spend_money.cash_card_purchases.details',
    'fees.table.add_money.load_cash_using_cash_card.name'
];

var FeesPage = React.createClass({
    mixins: [i18n('common/fees')],

    propTypes: {
        griffin: React.PropTypes.object.isRequired,
        dailyLimit: React.PropTypes.string.isRequired,
        monthlyLimit: React.PropTypes.string.isRequired,
        isCFPBCardPlusContentFlagEnabled: React.PropTypes.bool,
        instanceLocation: React.PropTypes.object.isRequired
    },

    getInitialState: function () {
        return { isBackToTopButtonVisible: false };
    },

    componentDidMount: function () {
        document.title = 'PayPal: ' + this.i18nWithCardConfig('fees.header_v2');
        Analytics.trackPage({id: 'fees', data: this.props});
        window.addEventListener('scroll', this.setBackToTopButtonVisibility);
    },

    componentWillUnmount: function () {
        window.removeEventListener('scroll', this.setBackToTopButtonVisibility);
    },

    setBackToTopButtonVisibility: function () {
        var isBackToTopButtonVisible = this.feesPageContainer.getBoundingClientRect().top < 0;

        this.setState({
            isBackToTopButtonVisible: isBackToTopButtonVisible
        });
    },

    shouldComponentUpdate: function (nextProps, nextState) {
        return nextState.isBackToTopButtonVisible !== this.state.isBackToTopButtonVisible;
    },

    backToTop: function (event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 500);
    },

    renderBackToTop: function () {
        var button = (
            <div key="backToTop" onClick={this.backToTop} className="vx_btn vx_btn-medium terms-back-to-top-btn">
                {this.i18n('fees.backToTop')}
            </div>
        );

        return (
            <ReactCSSTransitionGroup
                transitionName="backToTopButton"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}
            >
                {this.state.isBackToTopButtonVisible && button}
            </ReactCSSTransitionGroup>
        );
    },

    // Content layout
    renderHeader: function () {
        return (
            <header className="vx_modal-header text-center">
                <h2 className="fees-header vx_h2">{this.i18nWithCardConfig('fees.header_v2')}</h2>
            </header>
        );
    },

    renderSubheader: function () {
        return (
            <h3 className="fees-subheader text-center vx_h3">
                {this.i18n('fees.subheader')}
            </h3>
        );
    },

    renderCheckmark: function () {
        return <i className="icon icon-circled-checkmark-small fees-green-checkmark" />;
    },

    renderFeaturesTable: function () {
        var i18n = this.i18n;
        var checkmark = this.renderCheckmark();

        var featuresContent = FEATURES_KEYS.map(function (i) {
            var propKey = FEATURES_KEYS_PREFIX + i;
            return (
                <tr key={propKey}>
                    <td>{checkmark}</td>
                    <td>{i18n(propKey)}</td>
                </tr>
            );
        });

        return (
            <table className="fees-features-table">
                <tbody>
                    {featuresContent}
                </tbody>
            </table>
        );
    },

    renderFeesTable: function () {
        var i18n = this.i18n;
        const { insertLocalisedPercentageProperty, insertLocalisedCurrencyProperty } = griffinKeyCreator(this.props.griffin.griffinNumber);
        let currencyAmts = ['0', '2.50', '3.00', '3.95', '4.95', '5.00', '400', '500', '3000', '4000'].reduce((acc, cur) => insertLocalisedCurrencyProperty(acc, cur), {});
        let percentages = [1, 2.5, 5].reduce((acc, cur) => insertLocalisedPercentageProperty(acc, cur), {});
        let griffinInterpolations = { ...currencyAmts, ...percentages };

        var isCFPBCardPlusContentFlagEnabled = this.props.isCFPBCardPlusContentFlagEnabled;
        var headers = (
            <tbody>
                <tr>
                    {TABLE_HEADERS_KEYS.map((i) => {
                        var propKey = TABLE_KEYS_PREFIX + i + TABLE_HEADERS_KEYS_SUFFIX;
                        return <th className="fees-table-main-heading" key={propKey}> {i18n(propKey)} </th>;
                    })}
                </tr>
            </tbody>
        );

        var generateDetailsHeader = function (groupName) {
            return (
                <tr>
                    <th className="fees-table-sub-heading" colSpan="3">{i18n(TABLE_KEYS_PREFIX + groupName + TABLE_HEADERS_KEYS_SUFFIX)} </th>
                </tr>
            );
        };

        var generateDetailsRow = (groupName, rowName) => {
            var propKeyPrefix = TABLE_KEYS_PREFIX + groupName + '.' + rowName;

            var tableKeySuffix = TABLE_DETAILS_KEYS_SUFFIX;
            if (isCFPBCardPlusContentFlagEnabled && (rowName === 'load_cash_using_app' || rowName === 'load_cash_using_cash_card')) {
                tableKeySuffix = ['.name', '.amount', '.cash_plus.details'];
            }
            return (
                <tr key={propKeyPrefix}>
                    {tableKeySuffix.map((i) => {
                        var propKey = propKeyPrefix + i;
                        propKey = (propKey === 'fees.table.add_money.load_cash_using_cash_card.cash_plus.details' ||
                                    propKey === 'fees.table.add_money.load_cash_using_app.cash_plus.details')
                                    ? propKey + '_rebranding'
                                    : propKey;
                        if (v2ContentKeys.includes(propKey)) {
                            propKey += '_v2';
                        }
                        return (
                            <td key={propKey}>
                                <FormattedHTMLMessage
                                    message={this.i18nWithCardConfig(propKey, griffinInterpolations)}
                                />
                            </td>
                        );
                    })}
                </tr>
            );
        };

        var generateGroup = function (groupName, rowNameList) {
            return (
                <tbody key={groupName}>
                    {generateDetailsHeader(groupName)}
                    {rowNameList.map((rowName) => { return generateDetailsRow(groupName, rowName); })}
                </tbody>
            );
        };

        var groupCashLoads = (
            <tbody key={'cash_load'}>
                {generateDetailsHeader('cash_load')}
                <tr key="fees.table.cash_load.daily">
                    <td>{i18n('fees.table.cash_load.daily.name')}</td>
                    <td>{this.props.dailyLimit}</td>
                    <td rowSpan="2"><FormattedHTMLMessage message={i18n('fees.table.cash_load.daily_monthly.details', { dailyLimit: this.props.dailyLimit, monthlyLimit: this.props.monthlyLimit })} /></td>
                </tr>

                <tr key="fees.table.cash_load.monthly">
                    <td>{i18n('fees.table.cash_load.monthly.name')}</td>
                    <td>{this.props.monthlyLimit}</td>
                </tr>
            </tbody>
        );

        return (
            <table>
                {headers}
                {generateGroup('get_started', ['card_fee'])}
                {generateGroup('monthly_usage', ['monthly_fee', 'inactivity'])}
                {generateGroup('add_money', ['load_cash_using_app', 'load_cash_using_cash_card', 'direct_deposit', 'transfer', 'receive', 'check_cashed', 'check_cashing_payroll_gov', 'check_cashing_others'])}
                {generateGroup('spend_money', ['cash_card_purchases'])}
                {generateGroup('declined_trans', ['spending_declined', 'atm_declined'])}
                {generateGroup('withdrawals', ['in_network_atm', 'out_network_atm', 'bank_counter'])}
                {generateGroup('usage_limits', ['daily_atm', 'daily_purchase'])}
                {generateGroup('outside_us', ['international_transaction', 'interational_atm'])}
                {generateGroup('processing_policies', ['negative_balance', 'card_replacement_std'])}
                {generateGroup('sending_money', ['send_from_ppbalance'])}
                {groupCashLoads}
            </table>
        );
    },

    renderFooter: function () {
        return (
            <div>
                <div className="vx_text-body_secondary"><FormattedHTMLMessage message={this.i18nWithCardConfig('fee.footer.about_trems_v2')} /></div>
                <br />
                <div className="vx_text-body_secondary"><FormattedHTMLMessage message={this.i18nWithCardConfig('fees.footer.about_ppcashcard_v2')} /></div>
                <br />
                <div className="vx_text-body_secondary"><FormattedHTMLMessage message={this.i18nWithCardConfig('fees.footer.about_debit_benefits_v2')} /></div>
            </div>
        );
    },

    render: function () {
        const { cdnHostName } = this.props.instanceLocation;
        return (
            <div className="fees-page vx_modal-content" id="fees-page" ref={(e) => { this.feesPageContainer = e; }}>
                {this.renderHeader()}
                {this.renderSubheader()}

                <div className="fees-image-features-container">
                    <div className="fees-image-left">
                        <img src={`https://${cdnHostName}/ucs/placeholder/cons-debit-card-with-app.png`} alt="" />
                    </div>
                    <div className="fees-features-right">
                        {this.renderFeaturesTable()}
                    </div>
                </div>

                <div className="fees-table-container">
                    {this.renderFeesTable()}
                </div>

                {this.renderFooter()}

                {this.renderBackToTop()}
            </div>
        );
    }
});

module.exports = FeesPage;
/* eslint i18n-scan/no-inline-concatenation: 0 */



/** WEBPACK FOOTER **
 ** ./public/js/components/common/FeesPage.react.js
 **/